import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolClassesOneToOne = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-5 md:col-span-6">
          <Image
            width={360}
            height={268}
            className="flex-image"
            src="/images/tutoring.png"
            alt="Tutoring Image"
          />
        </div>
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.effectiveClasses.explanations.title.oneToOne')}
          </h2>
          <p className="school-section-description">
            {t('service.school.effectiveClasses.explanations.detail.oneToOne')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolClassesOneToOne;
